const redirects = [
  {
    from: '/community',
    to: '/community/post',
  },
];

export default redirects;
